import script from "./ExportProfileTransferSftp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportProfileTransferSftp.vue?vue&type=script&setup=true&lang=ts"

import "./ExportProfileTransferSftp.vue?vue&type=style&index=0&id=dec77f14&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dec77f14"]])

export default __exports__